import { render, staticRenderFns } from "./search-payment-descriptions-dialog.vue?vue&type=template&id=5ea84ecb&scoped=true&"
import script from "./search-payment-descriptions-dialog.vue?vue&type=script&lang=js&"
export * from "./search-payment-descriptions-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea84ecb",
  null
  
)

export default component.exports